<template>
  <div class="posts">
    <v-container grid-list-sm>
      <v-layout row wrap>
        <v-flex sm4 v-if="posts" class="sum-fixed__wrapper">
          <div class="sum-fixed-posts">
            <div v-for="post in posts" :key="post.id">
              <div v-if="(lang === 'de' && post.post_language !== 'en') || (lang === 'en' && post.post_language === 'en')"
                :id="'sum_' + post.id" :class="getActiveClass(post.id)">
                <div class="sum-type-section">{{ translate['Beitrag'][lang] }}</div>
                <a :href="'/posts/' + post.id" v-html="post.title.rendered" class="lnk_nostyle"
                  v-on:click="setCurrentPost(post.id, $event)"></a>
              </div>
            </div>
          </div>
        </v-flex>
        <v-flex sm4 class="progress-wrapper" v-else>
          <v-progress-circular indeterminate color="grey"></v-progress-circular>
        </v-flex>
        <template v-if="currentPost">
          <v-flex sm7>
            <div class="col-inner col-highlight">
              <h1 id="g-main-content-title" v-html="currentPost.title.rendered"></h1>
              <div class="ffs" v-html="currentPost.content.rendered"></div>
            </div>
          </v-flex>
        </template>
        <template v-else-if="firstpost.hasOwnProperty(lang)">
          <v-flex sm7>
            <div class="col-inner col-highlight">
              <h1 id="g-main-content-title" v-html="firstpost[lang].title.rendered"></h1>
              <div class="ffs" v-html="firstpost[lang].content.rendered"></div>
            </div>
          </v-flex>
        </template>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  firstSum: 0,
  name: 'Posts',
  data () {
    return {
      msg: 'Posts',
      cssClass: this.$options.name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase(),
      loading: true,
      currentPost: null,
      sum: null,
      isScrolling: null,
      scrollHasListener: false
    }
  },
  created () {
    if (this.posts.length === 0) {
      this.getPosts()
    }
  },
  mounted () {
    if (this.posts.length > 0) {
      this.loading = false
      if (this.$route.params.pid) {
        this.setCurrentPost(Number(this.$route.params.pid))
      }
      this.sum = document.querySelector('.sum-fixed-posts')
      this.addScrollListener()
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll, false)
  },
  watch: {
    posts: function () {
      if (this.posts.length > 0 && this.$route.params.pid) {
        this.setCurrentPost(Number(this.$route.params.pid))
      }
      if (this.posts.length > 0) {
        this.sum = document.querySelector('.sum-fixed-posts')
        this.addScrollListener()
      }
    },
    '$route' (to, from) {
      this.setCurrentPost(to.params.pid)
    }
  },
  methods: {
    ...mapActions(['getPosts']),
    setCurrentPost (id, event) {
      if (event) {
        event.preventDefault()
      }
      this.posts.forEach(post => {
        if (post.id === id) {
          this.currentPost = post
          if (Number(this.$route.params.pid) !== id) {
            this.$router.push({ name: 'Post', params: { pid: id } })
          }
        }
      })
      let alle = document.getElementsByClassName('sum')
      for (var i = 0; i < alle.length; i++) {
        alle[i].classList.remove('sum-active')
      }
      let callerElement = document.getElementById('sum_' + id)
      if (callerElement) {
        callerElement.classList.add('sum-active')
      }
      let el = document.getElementById('g-main-content-title')
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }
    },
    getActiveClass (id) {
      if (this.$route.params.pid) {
        if (Number(this.$route.params.pid) === id) {
          return 'col-inner col-highlight sum sum-active'
        } else {
          return 'col-inner col-highlight sum'
        }
      } else {
        if (this.$options.firstSum === 0) {
          this.$options.firstSum = this.$options.firstSum + 1
          return 'col-inner col-highlight sum sum-active'
        } else {
          return 'col-inner col-highlight sum'
        }
      }
    },
    onScroll (event) {
      let sum = this.sum
      window.clearTimeout(this.isScrolling)
      this.isScrolling = setTimeout(function () {
        let windowWidth = window.innerWidth ||
          document.documentElement.clientWidth ||
          document.getElementsByTagName('body')[0].clientWidth
        let windowHeight = window.innerHeight ||
          document.documentElement.clientHeight ||
          document.getElementsByTagName('body')[0].clientHeight
        if (windowWidth >= 600) {
          let offset = document.documentElement.scrollTop
          if (offset > 48 && sum.offsetHeight < windowHeight) {
            sum.style.top = (offset) + 'px'
          } else {
            sum.style.top = '0'
          }
        } else {
          sum.style.top = '0'
        }
      }, 60)
    },
    addScrollListener () {
      if (!this.scrollHasListener) {
        window.addEventListener('scroll', this.onScroll, false)
        this.scrollHasListener = true
      }
    }

  },
  computed: {
    ...mapGetters([
      'posts',
      'firstpost',
      'translate',
      'lang'
    ])
  }
}
</script>
<style lang="scss">
.lnk_nostyle {
  text-decoration: none;
}

.sum-fixed-posts {
  position: relative;
  transition: all 0.5s;
}

.progress-wrapper {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Posts.vue